import { Box, CircularProgress } from '@mui/material';
import { AppLayout, AuthLayout } from 'components/layout';
import { PAGE_LIST } from 'constant/pages';
import { Home, Setting, Tag, UserAdd } from 'pages';
import QueryString from 'qs';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import { getUser } from 'utils/fetch';

function App() {
  const getTokenFromQueryStrAndGetAuth = async (str: string) => {
    const queryString = str.split('?')[1];
    const query = QueryString.parse(queryString);
    return await getUser(query?.accessToken as string | undefined);
  };

  const router = createBrowserRouter([
    {
      element: <AuthLayout />,
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      children: [
        {
          path: PAGE_LIST.SETTING.pathname(),
          element: <Setting />,
        },
      ],
    },
    {
      path: '/',
      element: <AppLayout />,
      loader: async ({ request }) => {
        return await getTokenFromQueryStrAndGetAuth(request.url);
      },
      errorElement: <Navigate to={PAGE_LIST.SETTING.pathname()} />,
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: PAGE_LIST.TAG.pathname(),
          element: <Tag />,
        },
        {
          path: PAGE_LIST.USER_ADD.pathname(),
          element: <UserAdd />,
        },
        {
          path: PAGE_LIST.USER_DETAIL.pathname(),
          element: <UserAdd />,
        },
      ],
    },
  ]);

  return (
    <RouterProvider
      router={router}
      fallbackElement={
        <Box
          sx={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress sx={{ color: '#1A96F0' }} />
        </Box>
      }
    />
  );
}

export default App;
